import React from 'react';
import SIcon from './SIcon';
import { faCamera } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faCamera} fa />;

export default Icon;
